import { render } from "./StopMessages.vue?vue&type=template&id=b4a0938c"
import script from "./StopMessages.vue?vue&type=script&lang=js"
export * from "./StopMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__